/** Where a managed-connection-creation flow was started from. */
export enum ManagedConnectionSource {
  HeaderMenu = "header_menu",
  EmptyState = "empty_state",
  NudgeCard = "nudge_card",
  NudgeCardQuickPick = "nudge_card_quick_pick",
  AppDetails = "app_details",
}
